
export const BODY_CLASS_LANDING_PAGE = 'layout-fixed sidebar-expand-lg sidebar-open bg-body-tertiary';

export const BODY_CLASS_SIGN_IN = 'login-page bg-body-secondary';

export const TIMEOUT_DIALOG_MESSAGE = 1200;